import React from 'react'
import './Details.css'
import classnames from 'classnames'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  arrows: true,
  slidesToShow: 6,
  slidesToScroll: 4,

  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        infinite: true,
        slidesToScroll: 1,
        swipeToSlide: true,
        variableWidth: true
      }
    }
  ]
}

const Details = ({ mealDetail, isLoading }) => (
  <div className="details">
    {mealDetail.specificationsDetails ? (
      <div className="meal-detail-container">
        <Slider {...settings}>
          {mealDetail.specificationsDetails &&
            mealDetail.specificationsDetails.map((detail, i) => {
              return (
                <div
                  className={classnames('meal-detail', { loading: isLoading })}
                  key={i}>
                  <img
                    className="detail-img"
                    alt={detail.label}
                    src={detail.image}
                  />
                  <div>{detail.label}</div>
                </div>
              )
            })}
        </Slider>
      </div>
    ) : null}
  </div>
)

export default Details



// WEBPACK FOOTER //
// ./src/modules/MealDetail/components/Details/index.js